import { AController } from "@eagerlogic/react-mvc";
import { AddVacationModel, AddVacationDialogModel, UserModel } from "./AddVacationModel";
import { Meta, EUserRole } from "utils/meta";
import { Rpc, ApiException } from "rpc/rpc";
import { VacationRpc, THalfDayType, VacationDto } from "rpc/VacationRpc";
import { VacationData } from "data/VacationData";
import { UserVacationStatisticsData } from "data/UserVacationStatisticsData";
import { UpcomingEventsData } from "data/UpcomingEventsData";

export class AddVacationController extends AController<AddVacationModel> {

    private onAddVacationListener: { (): void };

    public constructor(addVacationListener: { (): void }) {
        super();
        this.onAddVacationListener = addVacationListener;
    }

    protected createInitialModel(): AddVacationModel {
        var res = new AddVacationModel();

        return res;
    }

    public showDialog() {
        this.model.addVacationDialogModel = new AddVacationDialogModel();
        if (Meta.get().userRole.level >= EUserRole.HR.level) {
            this.model.addVacationDialogModel.isUserSelectable = true;
            for (var u of Meta.get().users) {
                this.model.addVacationDialogModel.users.push({ id: "" + u.id, name: u.name });
            }
        }
        this.model.addVacationDialogModel.selectedUser = "" + Meta.get().userId;

        this.render(this.model);
    }

    public hideDialog() {
        this.model.addVacationDialogModel = null;
        this.render(this.model);
    }

    public async saveVacation(userId: string, isHalfDay: boolean, startDate: Date, endDate: Date, type: string, dayPart: string, description: string) {
        this.model.addVacationDialogModel.globalError = null;
        this.model.addVacationDialogModel.dayPartError = null;
        this.model.addVacationDialogModel.startDateError = null;
        this.model.addVacationDialogModel.endDateError = null;
        this.model.addVacationDialogModel.selectedUserError = null;
        this.model.addVacationDialogModel.typeError = null;

        try {
            var res = await VacationRpc.add(
                parseInt(userId),
                (isHalfDay ? dayPart : null) as THalfDayType,
                startDate == null ? null : startDate.toISOString(),
                endDate == null ? null : endDate.toISOString(),
                type,
                description
            );

            this.model.addVacationDialogModel = null;
            this.render(this.model);

            if (this.onAddVacationListener != null) {
                this.onAddVacationListener();
            }
        } catch (ex) {
            if (ex instanceof ApiException) {
                this.model.addVacationDialogModel.globalError = ex.message;
                this.model.addVacationDialogModel.dayPartError = ex.fieldErrors["halfDayType"];
                this.model.addVacationDialogModel.startDateError = ex.fieldErrors["startDate"];
                this.model.addVacationDialogModel.endDateError = ex.fieldErrors["endDate"];
                this.model.addVacationDialogModel.selectedUserError = ex.fieldErrors["userId"];
                this.model.addVacationDialogModel.typeError = ex.fieldErrors["type"];
                this.render(this.model);
            } else {
                this.model.addVacationDialogModel.globalError = "" + ex;
            }

        }
    }

}